import { Formik, FormikConfig, FormikValues } from 'formik';

type FormProps<Values extends FormikValues> = FormikConfig<Values>;

export function MuiForm<Values extends FormikValues = FormikValues>(props: FormProps<Values>) {
    return <Formik {...props} />;
}
